import { createSlice } from '@reduxjs/toolkit'

/**
 * Redux slice for storing dashboard recognition results.
 * Results come from the Roboflow object-detection model via /recognition/analyze
 * and the image URL is a local blob URL produced by the upload step.
 */
const recognitionSlice = createSlice({
  name: 'recognition',
  initialState: {
    /** Local blob URL for displaying the analyzed image. */
    imageUrl: null,
    /**
     * Detected labels (Roboflow predictions adapted to the legacy shape).
     * Shape: [{ Name: string, Confidence: number, Geometry: { BoundingBox: { Width, Height, Left, Top } } }]
     */
    labels: []
  },
  reducers: {
    SET_ANALYSIS_RESULT: (state, { payload }) => {
      state.imageUrl = payload.imageUrl ?? null
      state.labels = payload.labels ?? []
    },
    CLEAR_ANALYSIS: state => {
      state.imageUrl = null
      state.labels = []
    }
  }
})

export default recognitionSlice

export const recognitionActions = recognitionSlice.actions

export const recognitionSelectors = {
  selectRecognition: state => state.recognition,
  selectImageUrl: state => state.recognition.imageUrl,
  selectLabels: state => state.recognition.labels
}
